import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { QueryExecution } from '../../types';
import LiveSearchMetadataGridController from '../controller/LiveSearchMetadataGridController';

export class LiveSearchMetadataGridComponent extends BaseWebComponentElement {
  public controller: LiveSearchMetadataGridController;
  private queryExecution: QueryExecution | null = null;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: LiveSearchMetadataGridController,
    });
  }

  public getQueryExecution(): QueryExecution | null {
    return this.queryExecution;
  }

  public setQueryExecution(queryExecution: QueryExecution | null): void {
    this.queryExecution = queryExecution;
    this.controller.render();
  }
}
